 // RB-MY01-PalmGarden.web/src/components/SimpleGrid.tsx
import React from 'react';
import { Grid as MuiGrid } from '@mui/material';

// Simple Grid Container component
export const GridContainer: React.FC<any> = ({ children, ...props }) => {
  return (
    <MuiGrid container {...props}>
      {children}
    </MuiGrid>
  );
};

// Simple Grid Item component
export const GridItem: React.FC<any> = ({ children, ...props }) => {
  return (
    <MuiGrid item {...props}>
      {children}
    </MuiGrid>
  );
};